import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { SsnInput as SparkSsnInput } from "react-spark";

import {
  withValidationOutputDefaultProps,
  withValidationOutputPropTypes,
  sharedFormInputPropTypes,
  sharedFormInputDefaultProps
} from "../hocs/prop-types";
import { withValidation } from "../hocs/WithValidation";

class SsnInput extends Component {
  componentDidMount() {
    this.props.context.registerFormElement({
      value: this.props.value,
      name: this.props.name,
      valid: this.props.validateOnRegisterUpdate.apply(this),
      validate: this.props.handleValidation
    });
  }

  componentDidUpdate() {
    this.props.context.updateFormElement({
      value: this.props.value,
      name: this.props.name,
      valid: this.props.validateOnRegisterUpdate.apply(this)
    });
  }

  componentWillUnmount() {
    this.props.context.deregisterFormElement({
      name: this.props.name,
    }, this);
  }

  handlePaste(event) {
    if(this.props.context && this.props.context.addPField) {
      this.props.context.addPField(event.target.name);
    }
  }

  render() {
    const {
      className,
      context,
      disabled,
      errorMessage,
      handleBlur,
      handleChange,
      hideLabel,
      id,
      label,
      name,
      pattern,
      placeholder,
      value,
      width
    } = this.props;
    const patternProp = pattern == null ? {} : { pattern };
    const placeholderProp = placeholder == null ? {} : { placeholder };

    return (
      <SparkSsnInput
        className={className}
        disabled={disabled}
        error={errorMessage}
        id={id}
        label={hideLabel ? "" : label}
        name={name}
        onChange={event => handleChange(event, context)}
        onBlur={event => handleBlur(event, context.handleChange)}
        onPaste={event => this.handlePaste(event)}
        width={width}
        {...patternProp}
        {...placeholderProp}
        value={value}
      />
    );
  }
}

SsnInput.defaultProps = {
  ...withValidationOutputDefaultProps,
  ...sharedFormInputDefaultProps,
  pattern: null,
  placeholder: "000-00-0000",
  value: ""
};

SsnInput.propTypes = {
  ...withValidationOutputPropTypes,
  ...sharedFormInputPropTypes,
  pattern: PropTypes.string,
  value: PropTypes.string.isRequired
};

export default withValidation(SsnInput);
